import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";

// Taken from https://github.com/WalletConnect/walletconnect-monorepo/blob/master/packages/qrcode-modal/src/browser.ts
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { getColorMode } from '../../colorMode';
import { windowRef } from '../../MockWindow';
import { generateGUID } from '../../utils/generate-uuid';
import { replaceInTemplate } from '../../utils/replace-in-template';
import { alertTemplates } from './alert-templates';
import { preparePairingAlert } from './PairingAlert';
var lastFocusedElement;
var document;

if (typeof window !== 'undefined' && typeof window.document !== 'undefined') {
  document = window.document;
}

var timeout = {};

var addQR = function addQR(dataString) {
  if (typeof dataString === 'string') {
    return "<div id=\"beacon--qr__container\"><div id=\"beacon--qr__copy__container\"><button class=\"beacon-modal__button--outline\" id=\"beacon--qr__copy\">Copy</button></div></div>".concat(dataString);
  }

  return '';
};

var formatAlert = function formatAlert(id, body, title, buttons, hasPairingPayload) {
  var callToAction = title;
  var buttonsHtml = buttons.map(function (button, index) {
    return "<button id=\"beacon-alert-".concat(id, "-").concat(index, "\" class=\"beacon-modal__button").concat(button.style === 'outline' ? '--outline' : '', "\">").concat(button.text, "</button>");
  });
  var allStyles = alertTemplates.default.css;

  if (hasPairingPayload) {
    allStyles += alertTemplates.pair.css;
  }

  var alertContainer = alertTemplates.container;
  alertContainer = replaceInTemplate(alertContainer, 'main', hasPairingPayload ? alertTemplates.pair.html : alertTemplates.default.html);
  alertContainer = replaceInTemplate(alertContainer, 'callToAction', callToAction);
  alertContainer = replaceInTemplate(alertContainer, 'buttons', buttonsHtml.join(' '));
  alertContainer = replaceInTemplate(alertContainer, 'body', body);
  alertContainer = replaceInTemplate(alertContainer, 'id', id);

  if (alertContainer.indexOf('{{') >= 0) {
    var start = alertContainer.indexOf('{{');
    var end = alertContainer.indexOf('}}');
    console.error('Not all placeholders replaced!', alertContainer.substr(start, end - start));
    throw new Error('Not all placeholders replaced!');
  }

  return {
    style: allStyles,
    html: alertContainer
  };
};
/**
 * Close an alert by ID
 *
 * @param id ID of alert
 */


var closeAlert = function closeAlert(id) {
  windowRef.postMessage("closeAlert-".concat(id));
  return new Promise(function (resolve) {
    var _a;

    var wrapper = document.getElementById("beacon-alert-wrapper-".concat(id));

    if (!wrapper) {
      return resolve();
    }

    var elm = (_a = wrapper.shadowRoot) === null || _a === void 0 ? void 0 : _a.getElementById("beacon-alert-modal-".concat(id));

    if (elm) {
      var animationDuration = 300;
      var localTimeout = timeout[id];

      if (localTimeout) {
        clearTimeout(localTimeout);
        timeout[id] = undefined;
      }

      elm.className = elm.className.replace('fadeIn', 'fadeOut');
      window.setTimeout(function () {
        var parent = wrapper.parentNode;

        if (parent) {
          parent.removeChild(wrapper);
        }

        if (lastFocusedElement) {
          ;
          lastFocusedElement.focus(); // set focus back to last focussed element
        }

        resolve();
      }, animationDuration);
    } else {
      resolve();
    }
  });
};
/**
 * Close all alerts
 */


var closeAlerts = function closeAlerts() {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", new Promise(function (resolve) {
              return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                var openAlertElements, alertIds;
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        openAlertElements = document.querySelectorAll('[id^="beacon-alert-wrapper-"]');

                        if (!(openAlertElements.length > 0)) {
                          _context2.next = 9;
                          break;
                        }

                        alertIds = [];
                        openAlertElements.forEach(function (element) {
                          return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                            return _regeneratorRuntime.wrap(function _callee$(_context) {
                              while (1) {
                                switch (_context.prev = _context.next) {
                                  case 0:
                                    alertIds.push(element.id.split('-')[3]);

                                  case 1:
                                  case "end":
                                    return _context.stop();
                                }
                              }
                            }, _callee);
                          }));
                        });
                        _context2.next = 6;
                        return Promise.all(alertIds.map(closeAlert));

                      case 6:
                        resolve();
                        _context2.next = 10;
                        break;

                      case 9:
                        resolve();

                      case 10:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              }));
            }));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
};
/**
 * Show an alert
 *
 * @param alertConfig The configuration of the alert
 */
// eslint-disable-next-line complexity


var openAlert = function openAlert(alertConfig) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
    var _a, _b, body, title, timer, pairingPayload, disclaimer, closeButtonCallback, id, shadowRootEl, shadowRoot, wrapper, buttons, formattedBody, _formatAlert, style, html, styleEl, closeButton, closeButtonClick, disclaimerContainer, colorMode, elm, modal;

    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            body = alertConfig.body;
            title = alertConfig.title;
            timer = alertConfig.timer;
            pairingPayload = alertConfig.pairingPayload;
            disclaimer = alertConfig.disclaimerText; // eslint-disable-next-line @typescript-eslint/unbound-method

            closeButtonCallback = alertConfig.closeButtonCallback;
            _context9.next = 8;
            return closeAlerts();

          case 8:
            _context9.next = 10;
            return generateGUID();

          case 10:
            id = _context9.sent.split('-').join('');
            shadowRootEl = document.createElement('div');
            shadowRootEl.setAttribute('id', "beacon-alert-wrapper-".concat(id));
            shadowRoot = shadowRootEl.attachShadow({
              mode: 'open'
            });
            wrapper = document.createElement('div');
            wrapper.setAttribute('tabindex', "0"); // Make modal focussable

            shadowRoot.appendChild(wrapper);
            buttons = _toConsumableArray((_b = (_a = alertConfig.buttons) === null || _a === void 0 ? void 0 : _a.map(function (button) {
              var _a, _b;

              return {
                text: button.text,
                // eslint-disable-next-line @typescript-eslint/unbound-method
                actionCallback: (_a = button.actionCallback) !== null && _a !== void 0 ? _a : function () {
                  return Promise.resolve();
                },
                style: (_b = button.style) !== null && _b !== void 0 ? _b : 'outline'
              };
            })) !== null && _b !== void 0 ? _b : []);
            formattedBody = pairingPayload ? addQR(body) : body !== null && body !== void 0 ? body : '';
            _formatAlert = formatAlert(id, formattedBody, title, buttons, !!(pairingPayload === null || pairingPayload === void 0 ? void 0 : pairingPayload.p2pSyncCode)), style = _formatAlert.style, html = _formatAlert.html;
            wrapper.innerHTML = html;
            styleEl = document.createElement('style');
            styleEl.textContent = style;
            shadowRoot.appendChild(styleEl);

            if (timer) {
              timeout[id] = window.setTimeout(function () {
                return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
                  return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          _context4.next = 2;
                          return closeAlert(id);

                        case 2:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee4);
                }));
              }, timer);
            }

            document.body.prepend(shadowRootEl);
            closeButton = shadowRoot.getElementById("beacon-alert-".concat(id, "-close"));

            closeButtonClick = function closeButtonClick() {
              return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
                return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        if (closeButtonCallback) {
                          closeButtonCallback();
                        }

                        _context5.next = 3;
                        return closeAlert(id);

                      case 3:
                      case "end":
                        return _context5.stop();
                    }
                  }
                }, _callee5);
              }));
            };

            if (disclaimer) {
              disclaimerContainer = shadowRoot.getElementById("beacon--disclaimer");

              if (disclaimerContainer) {
                disclaimerContainer.innerHTML = disclaimer;
              }
            }

            colorMode = getColorMode();
            elm = shadowRoot.getElementById("beacon-alert-modal-".concat(id));

            if (elm) {
              elm.classList.add("theme__".concat(colorMode));
              elm.addEventListener('click', closeButtonClick); // Backdrop click dismisses alert
            }

            modal = shadowRoot.querySelectorAll('.beacon-modal__wrapper');

            if (modal.length > 0) {
              modal[0].addEventListener('click', function (event) {
                event.stopPropagation();
              });
            }

            lastFocusedElement = document.activeElement; // Store which element has been focussed before the alert is shown

            wrapper.focus(); // Focus alert for accessibility

            buttons.forEach(function (button, index) {
              var buttonElement = shadowRoot.getElementById("beacon-alert-".concat(id, "-").concat(index));

              if (buttonElement) {
                buttonElement.addEventListener('click', function () {
                  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
                    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            _context6.next = 2;
                            return closeAlert(id);

                          case 2:
                            if (!button.actionCallback) {
                              _context6.next = 5;
                              break;
                            }

                            _context6.next = 5;
                            return button.actionCallback();

                          case 5:
                          case "end":
                            return _context6.stop();
                        }
                      }
                    }, _callee6);
                  }));
                });
              }
            });

            if (closeButton) {
              closeButton.addEventListener('click', function () {
                return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
                  return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                      switch (_context7.prev = _context7.next) {
                        case 0:
                          _context7.next = 2;
                          return closeButtonClick();

                        case 2:
                        case "end":
                          return _context7.stop();
                      }
                    }
                  }, _callee7);
                }));
              });
            }

            window.addEventListener('keydown', function (event) {
              return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
                return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                  while (1) {
                    switch (_context8.prev = _context8.next) {
                      case 0:
                        if (!(event.key === 'Escape')) {
                          _context8.next = 3;
                          break;
                        }

                        _context8.next = 3;
                        return closeButtonClick();

                      case 3:
                      case "end":
                        return _context8.stop();
                    }
                  }
                }, _callee8);
              }));
            });

            if (!pairingPayload) {
              _context9.next = 42;
              break;
            }

            _context9.next = 42;
            return preparePairingAlert(id, shadowRoot, pairingPayload);

          case 42:
            return _context9.abrupt("return", id);

          case 43:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
};

export { closeAlert, closeAlerts, openAlert };